import {
  Component,
  Input,
  OnChanges,
  HostBinding,
  OnDestroy,
  OnInit,
  SimpleChange,
  SimpleChanges,
} from '@angular/core';
import { Subscription} from 'rxjs';
import { select, Store} from '@ngrx/store';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { faAngleDown, faAngleUp} from '@fortawesome/pro-light-svg-icons';
import { faInfoCircle} from '@fortawesome/pro-regular-svg-icons';
import {
  Edition,
  SearchResultResponse,
  VendorType,
} from '../../models/entity';
import { FullEntityState, selectInstanceAboutInfoRapido } from '../../reducers/full-entity.reducer';
import { loadFormatGroupAboutInfoRapido } from '../../actions/full-entity.actions';
import { isAuthorizedInKeycloak } from '../../../keycloak/reducers/keycloak.reducer';
import { tryToGetItTabRapido } from '../../actions/entity.actions';
import { ResourceSharingOffer } from '../../models/rapido-offer';
import { RapidoOffersService } from '../../../services/rapido-offers.service';
import { SearchResult } from 'search/models/search-results';
import { FeatureToggleService } from 'app/services/feature-toggle.service';
import { EditionsSidebarComponent } from 'search/full-card/components/editions/editions-sidebar/editions-sidebar.component';
import { RapidoAboutPopupComponent } from '../rapido-about-popup/rapido-about-popup.component';

@Component({
  selector: 'app-location-and-edition-table-rapido-item',
  templateUrl: './location-and-edition-table-rapido-item.component.html',
  styleUrls: ['./location-and-edition-table-rapido-item.component.scss']
})
export class LocationAndEditionTableRapidoItemComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public edition: Edition;
  @Input() public tabName: string;
  @Input() public label: string;
  @Input() public fgTitle: string;
  @Input() public isbn: string;
  public subscriptions = new Subscription();

  public isExpandable: boolean;
  public instanceResults: any;
  public expandedLocationInformation: Edition;
  public readonly arrowIconDown = faAngleDown;
  public readonly arrowIconUp = faAngleUp;
  public readonly infoCircle = faInfoCircle
  public vendorType = VendorType;

  public isPatronAuthorized: boolean;
  public offer: ResourceSharingOffer;
  public offerError: boolean = false;
  public loading: boolean = false;
  public featureNewEditionsUXDesign: boolean;

  constructor(
    private readonly dialog: NgbModal,
    private readonly store: Store<FullEntityState>,
    private readonly offersService: RapidoOffersService,
    private readonly featureToggleService: FeatureToggleService,
  ) {
    this.featureNewEditionsUXDesign = this.featureToggleService.getToggles()['VDIS-33338_2025-12-31_new_editions_UX_design'];
  }

  @HostBinding('class.edition-information-row-expanded') public get isExpaned() {
    return this.edition.availability?.expanded;
  }

  public toggleEdition(edition: Edition) {
    this.expandedLocationInformation = this.expandedLocationInformation === edition ? null : edition;
  }

  public showDetails(edition: Edition) {
    if (this.featureNewEditionsUXDesign) {
      const modalRef = this.dialog.open(EditionsSidebarComponent,
        {windowClass: 'modal-right', ariaLabelledBy: 'drawer-items-title'});
      modalRef.componentInstance.editionId = edition.id;
      modalRef.componentInstance.rapido = true;
    } else {
      let context;
      if (this.instanceResults[edition.id]) {
        const instanceResult = this.instanceResults[edition.id] as SearchResultResponse;
        context = instanceResult.searchResult;
      } else {
        this.store.dispatch(loadFormatGroupAboutInfoRapido({id: edition.id}));
        context = {
          id: edition.id,
        };
      }

      const modalRef = this.dialog.open(RapidoAboutPopupComponent, {windowClass: undefined});
      modalRef.componentInstance.context = context;
      modalRef.componentInstance.tabLabel = this.label;
    }
  }

  public ngOnInit(): void {
    this.isExpandable = this.edition?.hasItems;
    this.subscriptions.add(this.store.pipe(select(selectInstanceAboutInfoRapido)).subscribe((info: SearchResult) => {
      this.instanceResults = info;
    }));

    this.subscriptions.add(
      this.store.select(isAuthorizedInKeycloak).subscribe((isAuthorized) => {
        this.isPatronAuthorized = isAuthorized;
        if (this.isPatronAuthorized) {
          this.getOffers();
        }
      })
    );
  }

  public ngOnChanges(changes: SimpleChanges) {
    const isEditionExpanded: SimpleChange = changes.isEditionExpanded;
    if (isEditionExpanded && !isEditionExpanded.currentValue) {
      this.expandedLocationInformation = null;
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.dialog.dismissAll();
  }

  public getOffers() {
    this.loading = true;
    this.offerError = false;
    this.offersService.getOffers(this.edition.recordId).subscribe((offers) => {
      if (offers.length) {
        this.offer = offers[0];
        this.offerError = false;
      } else {
        this.offer = null;
        this.offerError = true;
      }
      this.loading = false;
    });
  }

  public onGetIt(event: Event) {
    event.stopPropagation();
    this.store.dispatch(
      tryToGetItTabRapido({
        cardInfo: {
          title: this.fgTitle,
          id: this.edition.id,
          recordId: this.edition.recordId,
          tabName: this.tabName,
          isbn: this.isbn,
        },
      })
    );
  }
}
